import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

// import required modules
import { Pagination, Autoplay } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

/**
 * mobile images swiper component
 * @param images images data
 * @param activeIndex active eq
 * @param handleMouseEnter swiper slide mouse enter event
 */
const MobileSwiper = ({
  images,
  activeIndex,
}: {
  images: string[];
  activeIndex: number;
}) => {
  const [swiper, setSwiperInstance] = useState<any>(undefined);

  const pagination = {
    clickable: true,
  };

  return (
    <>
      <div className="mt-0">
        <Swiper
          slidesPerView={1}
          spaceBetween={0}
          className="m-detail-swiper"
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          loop={true}
          pagination={pagination}
          modules={[Pagination, Autoplay]}
        >
          {images.map((url, index) => (
            <SwiperSlide key={index}>
              <div
                className={`goods-swiper-slide ${
                  activeIndex === index ? "active" : ""
                }`}
              >
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img src={url} alt=""/>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <style jsx global>
        {`
          .m-detail-swiper .goods-swiper-slide {
            height: 427px;
            background: #f6f6f6;
            border: none;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }
          .m-detail-swiper .goods-swiper-slide img {
            max-width: 80%;
            max-height: 80%;
          }

          .m-detail-swiper .goods-swiper-slide.active {
            border-color: none;
          }

          .m-detail-swiper .swiper-pagination-bullet {
            height: 2px;
            width: 36px;
            border-radius: 0;
            background: #e4e4e4;
            transform: skewX(-45deg);
            opacity: 1;
            margin:0 2px !important;
          }

          .m-detail-swiper .swiper-pagination-bullet-active {
            background: #d91d22;
          }

          .m-detail-swiper .swiper-horizontal > .swiper-pagination-bullets,
          .m-detail-swiper
            .swiper-pagination-bullets.swiper-pagination-horizontal {
            bottom: 16px;
          }
        `}
      </style>
    </>
  );
};

export default MobileSwiper;
